import s1 from '@/assets/scenes/s1/spritesAnimations'
import s2 from '@/assets/scenes/s2/spritesAnimations'
import s3 from '@/assets/scenes/s3/spritesAnimations'
import s4 from '@/assets/scenes/s4/spritesAnimations'
import s5 from '@/assets/scenes/s5/spritesAnimations'
import s6 from '@/assets/scenes/s6/spritesAnimations'
import s7 from '@/assets/scenes/s7/spritesAnimations'
import s8 from '@/assets/scenes/s8/spritesAnimations'

export default {
  ...s1,
  ...s2,
  ...s3,
  ...s4,
  ...s5,
  ...s6,
  ...s7,
  ...s8
}



// WEBPACK FOOTER //
// ./src/assets/spritesAnimations.js